import { Form, Input, message,Modal } from "antd";
import { useState } from "react";

type Props = {
  model: boolean;
  setModel: (val: boolean) => void;
  editdata: any;
  setEditData: (val: any) => void;
};

export const AddRoleAgentModel = ({
  model,
  setModel,
  editdata,
  setEditData,
}: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [roles, setRoles] = useState<any[]>([]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);

      setTimeout(() => {
        if (editdata) {
          // UPDATE ROLE (frontend)
          const updated = roles.map((r) =>
            r.id === editdata.id ? { ...r, role_name: values.Name.trim() } : r
          );
          setRoles(updated);
          message.success("Role updated successfully");
        } else {
          // ADD ROLE (frontend)
          const newRole = {
            id: Date.now(),
            role_name: values.Name.trim(),
          };
          setRoles([...roles, newRole]);
          message.success("Role added successfully");
        }

        setLoading(false);
        form.resetFields();
        setEditData(null);
        setModel(false);
      }, 500);
    } catch (err: any) {
      message.error(err);
    }
  };

  // useEffect(() => {
  //   if (editdata) {
  //     form.setFieldsValue({
  //       Name: editdata?.role_name,
  //     });
  //   } else {
  //     form.resetFields();
  //   }
  // }, [editdata]);

  return (
    <Modal
      title={editdata ? "Edit Role" : "Add Role"}
      open={model}
      onCancel={() => {
        setModel(false);
        setEditData(null);
        form.resetFields();
      }}
      onOk={handleSubmit}
      okText={editdata ? "Update" : "Save"}
      confirmLoading={loading}
      centered
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Role Name"
          name="Name"
          rules={[
            { required: true, message: "Please enter role name" },

            {
              validator: (_, value) => {
                if (!value || value.trim() === "") {
                  return Promise.reject(new Error("Role name cannot be empty"));
                }

                return Promise.resolve();
              },
            },

            {
              min: 3,
              message: "Minimum 3 characters required",
            },
          ]}
        >
          <Input placeholder="Enter role name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
